// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestOperationTemplateRevisionId } from './HarvestOperationTemplateRevision';
import { operatorId } from './Operator';
import { cpLevelEnum } from './CpLevelEnum';
import { attributeKindEnum } from './AttributeKindEnum';
import { invResourceId } from './InvResource';
import { invResourceCategoryId } from './InvResourceCategory';
import { mediaAttachmentTypeEnum } from './MediaAttachmentTypeEnum';
import { textInputModeEnum } from './TextInputModeEnum';
import { harvestAttributeCodeCode } from './HarvestAttributeCode';
import { templateAttributeRole } from './TemplateAttributeRole';
import { harvestAttributeLineageId } from './HarvestAttributeLineage';
import { z } from 'zod';
export const harvestOperationTemplateAttributeId = (z.number());
export const harvestOperationTemplateAttribute = z.object({
    id: harvestOperationTemplateAttributeId,
    operation_template_id: harvestOperationTemplateRevisionId,
    default_value_number: z.string().nullable(),
    default_value_measurement_unit: z.string().nullable(),
    default_check_value: z.boolean().nullable(),
    display_order: z.number().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    is_control_point: z.boolean(),
    cp_default_check_value: z.boolean().nullable(),
    cp_default_number_abs_tol_lower: z.string().nullable(),
    cp_default_number_abs_tol_upper: z.string().nullable(),
    cp_default_number_rel_tol_lower: z.string().nullable(),
    cp_default_number_rel_tol_upper: z.string().nullable(),
    cp_default_number_target: z.string().nullable(),
    cp_default_number_unit: z.string().nullable(),
    cp_details: z.string().nullable(),
    cp_level: cpLevelEnum.nullable(),
    name: z.string(),
    description: z.string().nullable(),
    kind: attributeKindEnum,
    measurement_default_unit: z.string().nullable(),
    measurement_instructions: z.string().nullable(),
    computed_number_formula: z.string().nullable(),
    computed_number_result_base_unit: z.string().nullable(),
    computed_number_result_display_unit: z.string().nullable(),
    check_instructions: z.string().nullable(),
    inv_item_resource_id: invResourceId.nullable(),
    inv_item_resource_category_id: invResourceCategoryId.nullable(),
    media_attachment_type: mediaAttachmentTypeEnum.nullable(),
    text_input_mode: textInputModeEnum.nullable(),
    text_instructions: z.string().nullable(),
    text_options: z.unknown().nullable(),
    code: harvestAttributeCodeCode.nullable(),
    content_html: z.string().nullable(),
    role: templateAttributeRole,
    lineage_id: harvestAttributeLineageId,
    applicable_scale_ids: z.number().array().nullable(),
});
export const harvestOperationTemplateAttributeInitializer = z.object({
    id: harvestOperationTemplateAttributeId.optional(),
    operation_template_id: harvestOperationTemplateRevisionId,
    default_value_number: z.string().optional().nullable(),
    default_value_measurement_unit: z.string().optional().nullable(),
    default_check_value: z.boolean().optional().nullable(),
    display_order: z.number().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    is_control_point: z.boolean().optional(),
    cp_default_check_value: z.boolean().optional().nullable(),
    cp_default_number_abs_tol_lower: z.string().optional().nullable(),
    cp_default_number_abs_tol_upper: z.string().optional().nullable(),
    cp_default_number_rel_tol_lower: z.string().optional().nullable(),
    cp_default_number_rel_tol_upper: z.string().optional().nullable(),
    cp_default_number_target: z.string().optional().nullable(),
    cp_default_number_unit: z.string().optional().nullable(),
    cp_details: z.string().optional().nullable(),
    cp_level: cpLevelEnum.optional().nullable(),
    name: z.string(),
    description: z.string().optional().nullable(),
    kind: attributeKindEnum,
    measurement_default_unit: z.string().optional().nullable(),
    measurement_instructions: z.string().optional().nullable(),
    computed_number_formula: z.string().optional().nullable(),
    computed_number_result_base_unit: z.string().optional().nullable(),
    computed_number_result_display_unit: z.string().optional().nullable(),
    check_instructions: z.string().optional().nullable(),
    inv_item_resource_id: invResourceId.optional().nullable(),
    inv_item_resource_category_id: invResourceCategoryId.optional().nullable(),
    media_attachment_type: mediaAttachmentTypeEnum.optional().nullable(),
    text_input_mode: textInputModeEnum.optional().nullable(),
    text_instructions: z.string().optional().nullable(),
    text_options: z.unknown().optional().nullable(),
    code: harvestAttributeCodeCode.optional().nullable(),
    content_html: z.string().optional().nullable(),
    role: templateAttributeRole.optional(),
    lineage_id: harvestAttributeLineageId,
    applicable_scale_ids: z.number().array().optional().nullable(),
});
export const harvestOperationTemplateAttributeMutator = z.object({
    id: harvestOperationTemplateAttributeId.optional(),
    operation_template_id: harvestOperationTemplateRevisionId.optional(),
    default_value_number: z.string().optional().nullable(),
    default_value_measurement_unit: z.string().optional().nullable(),
    default_check_value: z.boolean().optional().nullable(),
    display_order: z.number().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    is_control_point: z.boolean().optional(),
    cp_default_check_value: z.boolean().optional().nullable(),
    cp_default_number_abs_tol_lower: z.string().optional().nullable(),
    cp_default_number_abs_tol_upper: z.string().optional().nullable(),
    cp_default_number_rel_tol_lower: z.string().optional().nullable(),
    cp_default_number_rel_tol_upper: z.string().optional().nullable(),
    cp_default_number_target: z.string().optional().nullable(),
    cp_default_number_unit: z.string().optional().nullable(),
    cp_details: z.string().optional().nullable(),
    cp_level: cpLevelEnum.optional().nullable(),
    name: z.string().optional(),
    description: z.string().optional().nullable(),
    kind: attributeKindEnum.optional(),
    measurement_default_unit: z.string().optional().nullable(),
    measurement_instructions: z.string().optional().nullable(),
    computed_number_formula: z.string().optional().nullable(),
    computed_number_result_base_unit: z.string().optional().nullable(),
    computed_number_result_display_unit: z.string().optional().nullable(),
    check_instructions: z.string().optional().nullable(),
    inv_item_resource_id: invResourceId.optional().nullable(),
    inv_item_resource_category_id: invResourceCategoryId.optional().nullable(),
    media_attachment_type: mediaAttachmentTypeEnum.optional().nullable(),
    text_input_mode: textInputModeEnum.optional().nullable(),
    text_instructions: z.string().optional().nullable(),
    text_options: z.unknown().optional().nullable(),
    code: harvestAttributeCodeCode.optional().nullable(),
    content_html: z.string().optional().nullable(),
    role: templateAttributeRole.optional(),
    lineage_id: harvestAttributeLineageId.optional(),
    applicable_scale_ids: z.number().array().optional().nullable(),
});
//# sourceMappingURL=HarvestOperationTemplateAttribute.js.map